module.exports = __webpack_public_path__ + "static/img/item5.8558304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item5.png
// module id = TNB7
// module chunks = 0